import { RangeRef } from 'domains/reporter/RichTextEditor/core';

export type SlateMediaRecorderOptions = MediaRecorderOptions & {
  initialSelectionRef: RangeRef;
};

export class SlateMediaRecorder extends MediaRecorder {
  initialSelectionRef: RangeRef;
  startTimestamp: DOMHighResTimeStamp | null;
  endTimestamp: DOMHighResTimeStamp | null;
  id: string;
  constructor(newStream: MediaStream, options: SlateMediaRecorderOptions) {
    const { initialSelectionRef, ...opts } = options;
    super(newStream, opts);
    this.initialSelectionRef = initialSelectionRef;
    this.startTimestamp = null;
    this.endTimestamp = null;
    this.id = Date.now().toString();
  }

  startRecording(timeslice?: number) {
    this.start(timeslice);
    this.startTimestamp = performance.now();
  }

  stopRecording(cb?: (() => void) | null) {
    if (cb != null) {
      this.addEventListener('stop', () => {
        this.endTimestamp = performance.now();
        cb();
      });
    }
    this.stop();
  }

  /**
   * Get the cumulative duration of the recording in milliseconds. This number will grow until
   * the recording stops. If the recording has not yet started, returns -1.
   */
  getDurationMillis(): number {
    if (this.startTimestamp == null) {
      return -1;
    }
    if (this.endTimestamp == null) {
      return performance.now() - this.startTimestamp;
    }
    return this.endTimestamp - this.startTimestamp;
  }
}
